import { text } from '@storybook/addon-knobs';
import { storiesOf } from '@storybook/react';
import * as React from 'react';
import { LabelProps, Label } from '.';
// import { Input } from './';

storiesOf('label', module).add('default', () => {
  return <Label label={'hello'} />;
});
